import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {MatSnackBar} from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient,
              private snackBar: MatSnackBar) {}

  signinUser(loginData) {
    const options = {
      headers: new HttpHeaders().set('X-Timezone-Offset', this.getTimezoneOffset())
    };
    return this.http.post(
        'api/login?login=' + loginData.username + '&password=' + loginData.password,
        {observe: 'response', withCredentials: true},
        options);
  }

  getTimezoneOffset() {
    return String(new Date().getTimezoneOffset());
  }

  isAuthenticated() {
    const promise = new Promise(
      (resolve, reject) => {
        setTimeout(() => {
          resolve(localStorage.getItem('jwtToken') !== null);
        }, 800);
      }
    );
    return promise;
  }

  login(token, login) {
    localStorage.setItem('jwtToken', token);
    localStorage.setItem('login', login);
  }

  logout() {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('login');
  }

  openChangePass() {
    if (localStorage.getItem('changePass') === '1') {
      this.snackBar.open('Voulez-vous changer votre mot de passe !');
    }
  }

  closeChangePass() {
    this.snackBar.dismiss();
  }


}
